import { TenderStatus } from "constants/Constants";
import moment from "moment";
import { StatusFind, TranslateString } from "Utils/Common";

const SingleLoanViewOne = (props: any) => {
    return (
        <div className='mt-1 cu-table-border cu-text-small'>
                <table className="table table-sm table-bordered mb-0" >
                    <thead>
                        <tr className='align-top'>
                            {props?.userRole &&
                                <th scope="col" className='cu-bg-green text-left cu-three-width'>{TranslateString('priority')}</th>
                            }
                            <th scope="col" className='cu-bg-green text-left cu-six-width'>{TranslateString('loan_tender_id')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-three-width'>{TranslateString('customer_id')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-ten-width'>{TranslateString('customer_name')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-seven-width'>{TranslateString('loan_name')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-seven-width'>{TranslateString('current_capital')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-three-width'>{TranslateString('margin')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-three-width'>{TranslateString('loaner_grouped')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-seven-width'>{TranslateString('sännöitsijä')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-three-width'>{TranslateString('city')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-three-width'>{TranslateString('status')}</th>
                            <th scope="col" className='cu-bg-green text-left cu-five-width'>{TranslateString('deadline')}</th>
                            {props?.userRole &&
                                <th scope="col" className='cu-bg-green text-left'>{TranslateString('notes')}</th>
                            }
                            <th scope="col" className='cu-bg-green text-left cu-seven-width'>{TranslateString('number_of_tenders_received')}</th>
                        </tr>
                    </thead>
                    <tbody >
                        {<>
                            <tr className="cu-table-bg-lightgreen" key={Math.random()}>
                                {props?.userRole &&
                                    <td className='text-left fw-bold'>{props?.loanData?.LOAN_DATA?.loan_data_priority || "-"}</td>
                                }
                                <td className='text-left fw-bold'>{props?.loanData?.loan_tender_id || "-"}</td>
                                <td className='text-left fw-bold'>{props?.id}</td>
                                <td className='text-left'>{props?.loanData?.LOAN_DATA?.loan_data_customername || "-"}</td>
                                <td className='text-left'>{props?.loanData?.LOAN_DATA?.loan_data_name?.replace('Uusi laina:',TranslateString('new_loan')) || "-"}</td>
                                <td className='text-left fw-bold text-nowrap'>{props?.loanData?.LOAN_DATA?.loan_data_agreement || "-"}</td>
                                <td className='text-left fw-bold text-nowrap'>{props?.loanData?.LOAN_DATA?.loan_data_margin || "-"}</td>
                                <td className='text-left'>{props?.loanData?.LOAN_DATA?.loan_data_bank_group || "-"}</td>
                                <td className='text-left'>{props?.loanData?.LOAN_DATA?.CUST_DATA?.cust_data_manager_name || "-"}</td>
                                <td className='text-left'>{props?.loanData?.LOAN_DATA?.CUST_DATA?.cust_data_city || "-"}</td>
                                <td className='text-left'>{props?.loanData?.loan_tender_status ? TranslateString(props?.loanData?.loan_tender_status) : "-"}</td>
                                <td className='text-left'>{props?.loanData?.loan_tender_deadline ? moment(props?.loanData?.loan_tender_deadline).format("DD.MM.YYYY") : "-"}</td>
                                {props?.userRole &&
                                    <td className='text-left'>{props?.loanData?.loan_tender_notes || "-"}</td>
                                }
                                <td className='text-left fw-bold'>{props?.loanData?.no_of_tenders_received || "-"}</td>
                            </tr>
                        </>
                        }
                </tbody>
            </table>
        </div>
    );
};
export default SingleLoanViewOne;